.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  color: var(--ogm-white);
}
@media (max-width: 1023px) {
  .wrapper {
    margin-left: 5px;
  }
  .wrapper svg {
    height: 20px;
    width: 20px;
    transform: translateY(2px);
  }
}
@media (max-width: 767px) {
  .wrapper {
    margin-left: 0;
  }
}
@media (min-width: 1024px) {
  /* variant="icon" (OCGC-3133): oc-uk-style icon-only trigger — SettingsDropdown hover background +
     larger icon. height: 39px keeps it level with the other config-row menu buttons. Applies only
     when the UK header restyle flag is ON (NGF-6475). */
  .wrapperIcon {
    height: 39px;
    padding: 0 8px;
    background: none;
    border-radius: 5px;
    transition: background 0.4s ease;
  }
  .wrapperIcon:hover {
    background: rgba(238, 242, 243, 0.1);
  }
  .wrapperIcon svg {
    color: var(--ogm-header-dropdown-color, var(--oc-primary-white));
    height: 28px;
    width: 28px;
    transform: translateY(2px);
  }

  /* variant="pill" (default): icon + "Betslip" text on a dark pill. Both wrapper variants are
     explicit modifiers so deprecating one never silently restyles the other (NGF-6475). */
  .wrapperPill {
    height: 39px;
    padding: 0 8px;
    flex-direction: row-reverse;
    background: var(--ogm-timberwolves);
    border-radius: 3px;
    text-transform: uppercase;
    transition: background 0.4s ease;
  }
  .wrapperPill:hover {
    background: var(--ogm-timberwolves);
    color: var(--ogm-seahawks);
  }
  .wrapperPill svg {
    color: var(--ogm-seahawks);
    height: 16px;
    width: 16px;
    transform: translateY(2px);
  }
}
@media (max-width: 1023px) {
  .wrapper .miniBetslip {
    position: absolute;
    width: 100%;
    height: 100%;
  }
}
.wrapper .miniBetslip {
  position: relative;
  cursor: pointer;
  color: var(--ogm-white);
}
.wrapper .miniBetslip .betCount {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: auto;
  height: 18px;
  min-width: 18px;
  background: var(--ogm-header-color-3);
  background: var(--ogm-header-menu-badge-bg-color);
  border-radius: 12px;
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 10px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  color: var(--ogm-header-sports-bg-color);
  top: -10px;
  left: 16px;
}

.wrapperIcon .miniBetslip .betCount {
  background: var(--cxy-color-green-400, var(--ogm-seahawks, #00e889));
  color: var(--cxy-color-midnight-blue-600, #022e4a);
  font-weight: 700;
  left: auto;
  padding: 0 4px;
  right: -6px;
  top: -6px;
}
.betAdded {
  animation-name: pulse_animation;
  animation-duration: 200ms;
  transform-origin: 70% 70%;
  animation-timing-function: ease;
}
.betslipText {
  /* Inlined from the host typography module's fontBodyM (Public Sans / 14px) to keep this package a leaf. */
  font-family: 'Public Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
}
@media (max-width: 1023px) {
  .betslipText {
    display: none;
  }
}
.wrapper .betslipText {
  margin-right: 5px;
  color: inherit;
  cursor: pointer;
}

@keyframes pulse_animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
